var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"organization-detail"},[_c('span',[_vm._v("Managed by")]),_c('organization-logo',{staticClass:"organization-logo",attrs:{"logo":_vm.organizationLogo}}),_c('span',{staticClass:"organization-name"},[_vm._v(" "+_vm._s(_vm.organizationName)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }